export const sliderItems = [
  {
    id: 1,
    img: "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/I/Q/198253_1645777774.jpg",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fff",
  },
  {
    id: 2,
    img: "https://i.ibb.co/DG69bQ4/2.png",
    title: "AUTUMN COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "https://i.ibb.co/cXFnLLV/3.png",
    title: "LOUNGEWEAR LOVE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
  {
    id: 4,
    img: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/82/8772231/1.jpg?3926",
    title: "FASHIONABLE GOWN",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "e9f5f5",
  },
  {
    id: 5,
    img: "https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/45/0389021/1.jpg?7443",
    title: "FASHIONABLE GOWN",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "e9f5e1",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "SHIRT STYLE!",
    cat: "woman",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "LOUNGEWEAR LOVE",
    cat: "coat",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "LIGHT JACKETS",
    cat: "jeans",
  },
];

export const popularProducts = [
  {
    id: 1,
    title: "Indigenous Food",
    img: "https://www.informationng.com/wp-content/uploads/2016/05/por.jpg",
    price: 3244,
  },
  {
    id: 2,
    title: "Best African Food",
    img: "https://www.lacademie.com/wp-content/uploads/2022/02/popular-nigerian-foods.jpg",
    price: 3245,
  },
  {
    id: 3,
    title: "Traditional Food",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcV1wqf878keLp_gKCXCk9raXr0HS8dT9ZXA&usqp=CAU",
    price: 5434,
  },
  {
    id: 4,
    title: "Foreign Food",
    img: "https://englishlive.ef.com/blog/wp-content/uploads/sites/2/2013/06/jeffreyw.jpg",
    price: 3432,
  },
  {
    id: 5,
    title: "Foreign Dish",
    img: "https://www.crazymasalafood.com/wp-content/images/naan-1.jpg",
    price: 3424,
  },
  {
    id: 6,
    title: "Foreign Food",
    img: "https://247wallst.com/wp-content/uploads/2019/05/imageforentry2-iiz.jpg",
    price: 3241,
  },
  {
    id: 7,
    title: "Snacks",
    img: "https://www.gannett-cdn.com/-mm-/b2b05a4ab25f4fca0316459e1c7404c537a89702/c=0-0-1365-768/local/-/media/2018/07/03/USATODAY/usatsports/fortune-cookie-foreign-foods-actually-american.jpg",
    price: 3535,
  },
  {
    id: 8,
    title: "Foreign Food",
    img: "https://qph.cf2.quoracdn.net/main-qimg-d60e5be16716f62c054e95af8d82649e-lq",
    price: 2365,
  },
  {
    id: 9,
    title: "Foreign Dish",
    img: "https://www.smartertravel.com/wp-content/uploads/2014/06/stm53a1e48af1a6b20140618.jpg",
    price: 5612,
  },
  {
    id: 10,
    title: "Dish",
    img: "https://247wallst.com/wp-content/uploads/2018/07/imageforentry112.jpg",
    price: 3333,
  },
  {
    id: 11,
    title: "Garnish Rice",
    img: "https://www.translit.ie/wp-content/uploads/2016/08/photo-1453831362806-3d5577f014a4.jpg",
    price: 5512,
  },
  {
    id: 12,
    title: "Spaghetti",
    img: "https://247wallst.com/wp-content/uploads/2019/05/imageforentry1-js1.jpg",
    price: 5445,
  },
];
